import { closestCenter, pointerWithin, type CollisionDetection } from '@dnd-kit/core'

/**
 * **Wer liegt beim Ziehen auf Demnächst unter dem Zeiger?** (#303, Runde 2)
 *
 * Kandidaten sind alle **Zeilen** und die **leeren Tage** — ein Tag mit Zeilen tritt durch sie an. Ein leerer Tag zählt
 * aber nur, wenn der Zeiger IN ihm steht. Bis zum 10.10.2026 trat jeder leere Tag per `closestCenter` gegen die Zeilen
 * an: Jeder Monat baut alle seine Tage, auch die vergangenen, und deren Kästen verschieben sich während des Zuges. Im
 * E2E lag der Zug in jedem zweiten Lauf über dem leeren 8. Oktober, während der Zeiger auf einer Zeile vom 10. stand —
 * das Ablegen tat nichts.
 *
 * @example
 * <DndContext collisionDetection={upcomingDropTarget(dayKey => daysByKey.get(dayKey))} …>
 */
export function upcomingDropTarget(dayOf: (id: string) => { tasks: readonly unknown[] } | undefined): CollisionDetection {
  return args => {
    const emptyDays = args.droppableContainers.filter(c => dayOf(String(c.id))?.tasks.length === 0)
    const emptyDayUnderPointer = pointerWithin({ ...args, droppableContainers: emptyDays })
    if (emptyDayUnderPointer.length > 0) return emptyDayUnderPointer
    return closestCenter({ ...args, droppableContainers: args.droppableContainers.filter(c => dayOf(String(c.id)) === undefined) })
  }
}
